import { Link } from 'react-router-dom';

const stats = [
  { value: '204', label: '收录影视作品' },
  { value: '38', label: '每日资讯更新' },
  { value: '12', label: '精选主题片单' },
];

export default function HomeAbout() {
  return (
    <section className="w-full px-4 py-10 md:px-8 md:py-14">
      <div className="grid grid-cols-1 gap-6 rounded-lg border border-background-200 bg-background-100 p-5 md:grid-cols-[1.5fr_1fr] md:items-center md:p-8">
        <div>
          <p className="font-label text-[11px] font-semibold uppercase tracking-[0.2em] text-primary-600">
            About Doll Sister
          </p>
          <h2 className="mt-2.5 font-heading text-xl font-bold tracking-tight text-foreground-950 md:text-2xl">
            我们只做一件事：帮你找到下一部想看的片子
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            「玩偶姐姐」是一个不提供播放的影视内容平台。我们把有限的精力放在选片、分类和写作上：每一部推荐作品都有完整的资料、真实的剧情简介，以及编辑自己的判断。你可以按类型、年份、地区筛选，也可以在站内搜索里直接找到它。
          </p>
          <div className="mt-5 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              了解平台
              <i className="ri-arrow-right-line text-[14px]"></i>
            </Link>
            <Link
              to="/about"
              className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              <i className="ri-mail-send-line text-[15px]"></i>
              联系我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-3 md:gap-4">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className={`rounded-md p-3.5 ${
                index === 1 ? 'bg-accent-500 text-foreground-950' : 'bg-background-50 text-foreground-950'
              }`}
            >
              <p className="font-heading text-2xl font-bold leading-none">{stat.value}</p>
              <p className="mt-2 text-[11px] leading-tight text-foreground-700">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}